var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveBoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800293,
    y: 0.000488281,
    width: 20,
    height: 20,
    rx: 2.4,
    fill: "#3A3A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9533 15.8333C14.1617 15.8333 16.7867 13.2083 16.7867 9.99999C16.7867 6.79166 14.1617 4.16666 10.9533 4.16666C7.745 4.16666 5.12 6.79166 5.12 9.99999C5.12 13.2083 7.745 15.8333 10.9533 15.8333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62 10H13.2867",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBoot);
export default __webpack_public_path__ + "static/media/removeBoot.c3dbf30ebf78a3407bbbd5d290818d7a.svg";
export { ForwardRef as ReactComponent };